import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e25b23e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6e25b23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25b23e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e25b23e')) {
      api.createRecord('6e25b23e', component.options)
    } else {
      api.reload('6e25b23e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6e25b23e&scoped=true&", function () {
      api.rerender('6e25b23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/category-after-sale/index.vue"
export default component.exports